// MenuPanel.jsx

import React from 'react';

// CSS
import './MenuPanel.css';

/**
 * MenuPanel
 * 
 * Displays a panel for menu items.
 * 
 * @param {string} orientation - The orientation of the panel, either "HORIZONTAL" or "VERTICAL" (default is "VERTICAL").
 * @param {JSX.Element} children - The child components to render inside the panel.
 *  
 *
 * @returns {ReactNode} - MenuPanel.
 */
const MenuPanel = ({ orientation = "VERTICAL", children }) => {

    // ----- RENDER ----- //

    return (

        <div
          className="menu-panel-container"
          style={{
                flexDirection: orientation === "HORIZONTAL" ? "row" : "column",
            }}
        >
            {children}
        </div>
    );
};

// Dev Tools
MenuPanel.displayName = 'MenuPanel';

export default MenuPanel;
